import { StyledRow } from "App/global-style";
import styled from "styled-components";

export const ButtonContainer = styled(StyledRow)`
  justify-content: center;
  width: 100%;

  & button {
    color: ${({ theme }) => theme.insuranceDetailsCard.buttonColor ?? "black"};

    svg {
      margin-left: 4px;

      path {
        fill: ${({ theme }) =>
          theme.insuranceDetailsCard.useWhiteIcons ? "white" : "#bf0900"};
      }
    }
  }
`;

export const InsuranceProvider = styled.p`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 8px;
  width: 100%;
`;

export const AdviceLink = styled.a`
  color: ${({ theme }) => theme.brandColors.primary};
  font-size: ${({ theme }) => theme.fontSizes.xs};
`;
